import { assign } from 'lodash';

export interface UserRegistration {
  firstName: string;
  lastName: string;
  username: string;
  password: string;
}

export interface Registration {
  registrationCode: string;
  username: string;
}


export interface UserProfile {
  firstName: string;
  lastName: string;
  scopes: string[];
  email: string;
}


export class User implements UserProfile {
  firstName: string;
  lastName: string;
  scopes: string[];
  id: string;
  email: string;
  fullName: string;

  constructor(json: UserProfile) {
    this.firstName = json.firstName || '';
    this.lastName = json.lastName || '';
    this.id = json.email || '';
    this.email = json.email || '';
    this.scopes = json.scopes || [];
    this.fullName = this.firstName + ' ' + this.lastName;
  }

  static fromJSON(json) {
    return new User(json);
  }
}

export interface UserStatus {
  status: boolean,
  showModal: boolean
}



// WEBPACK FOOTER //
// ./src/app/auth/model/User.ts